import { render, staticRenderFns } from "./PagamentoRegistro.vue?vue&type=template&id=44791560"
import script from "./PagamentoRegistro.vue?vue&type=script&lang=js"
export * from "./PagamentoRegistro.vue?vue&type=script&lang=js"
import style0 from "./PagamentoRegistro.vue?vue&type=style&index=0&id=44791560&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports